import {
  tryCatch,
  pipe,
  when,
  propEq,
  drop,
  split,
  map,
  filter,
  isNil,
  isEmpty,
  fromPairs,
} from 'ramda'

export default tryCatch(
  pipe(
    when(propEq(0, '?'), drop(1)),
    split('&'),
    map(split('=')),
    filter(([__, v]) => !isNil(v) && !isEmpty(v)),
    map(([k, v]) => [k, decodeURIComponent(v)]),
    fromPairs,
  ),
  () => ({}),
)
